
import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvas_Form = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0,0)`)
      .attr('font-family', 'roboto')
     
      this.canvas_Form
      .append('rect')
      .attr('x', 0).attr('y', 1110)
      .attr('width', 1600).attr('height', 10)
      .attr('fill', '#D71638')
      
      this.canvas_Form
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/TrionFPU_r1.svg')
      .attr('x', 30).attr('y', 30).attr('width', 230)


      this.canvas_Form
      .append('text')
      .attr('transform', `translate(30, 108)`)
      .attr('font-size', 24)
      .attr('fill', '#000')
      .text(this.title.main)

      this.canvas_Form
      .append('text')
      .attr('transform', `translate(30, 125)`)
      .attr('font-size', 12)
      .attr('fill', '#44A9DF')
      .text(this.title.sub)

  

      // Load a JGS logo SVG
      this.loadSvg(
        this.canvas_Form, {
        x: 1460, y: 1060, width: 10,
        url : this.HOST + '/icon/Logo/JGS.svg'
      })


      // this.gmx_btn_Navigation(
      //   this.canvas_Form, 
      //   {type: 'home', x: 450, y: 97, scale: 0.8,}, 
      //   {
      //     remove: [this.model_Equipment, this.canvas_Equipment],
      //     dur: 500, timeout: 1000,
      //     exeFunc: this.draw_Model_Overall,
      //     data: {}
      //   }
      // )
    },




    

   

  }
}